<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <Banner :banner="bannerList"  @click="loseFocus()"></Banner>
    <!-- <div class="img_box">
      <div class="pc_img">
      <img alt="" src="static/picture/1-200g5115124326.jpg" style="width: 100%; height: auto;" /><img alt="" src="static/picture/1-200g5115131918.jpg" /></div>
        <div class="wap_img">
        <img alt="" src="static/picture/1-200g511513t91.jpg" style="width: 100%; height: auto;" /><img alt="" src="static/picture/1-200g5115144940.jpg" style="width: 1080px; height: 738px;" /><img alt="" src="static/picture/1-200g5115150447.jpg" /><img alt="" src="static/picture/1-200g5115156350.jpg" style="width: 1080px; height: 1067px;" /></div>
    </div> -->
    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">膳食补充</div>
      <ul>
        <li v-for="(item, index) in list1" :key="index">
          <a @click="toDetail(item.id)">
            <!-- <i>{{ item.sub1 }}</i> -->
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="pro_box container">
      <div style="text-align: center;font-size: 30px;font-weight: bold;padding: 30px 0 0 0; width: 100%;">可每日补充</div>
      <ul>
        <li v-for="(item, index) in list2" :key="index">
          <a @click="toDetail(item.id)">
            <!-- <i>{{ item.sub1 }}</i> -->
            <div class="li_img"><img :src="item.url" /></div>
            <div class="li_text">
              <p>
                {{ item.title }}
                <em v-html="item.english"></em>
              </p>
              <span>{{ item.sub2 }}</span>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <hr class="hr_1 mt0 mb30">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/MAESOUL/banner1.jpg'},
        {url:'static/picture/MAESOUL/banner2.jpg'},
        {url:'static/picture/MAESOUL/banner3.jpg'},
      ],
      list1: [
        { id: 1, title: '大麦青汁', english: 'MULBERRY LEAF GREEN', sub1: '温润舒爽', sub2: '粉质细腻 清爽营养', url: 'static/picture/MAESOUL/qing.png' },
      ],
      list2: [
        { id: 2, title: '全家益生菌', english: 'BI FIZUS（BB536）', sub1: '温润舒爽', sub2: '均衡健康  提升自护力', url: 'static/picture/MAESOUL/BB536.png' },
        { id: 3, title: '轻盈益生菌', english: 'BI FIZUS SLIM（B-3）', sub1: '温润舒爽', sub2: 'KO油腻 畅爽无忧', url: 'static/picture/MAESOUL/B3.png' },
      ],
    };
  },
  created() {
    this.id = this.$route.query.id;
    // this.judgeLogin();
  },
  methods: {
    toDetail(id) {
      this.$router.push({ path: '/HoctimeDetail', query: { id: id } });
    },
  }
};
</script>
<style scoped>
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------brand.html  start----------------*/
.img_box{
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
.img_box img{
	max-width: 100%;
	margin: 0 auto;
	display: block;
}
.img_box .video_box{
	width: 100%;
	margin: 0 auto;
	position: relative;
}
.img_box .video_box .zhezhao{
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
	z-index: 555;
	overflow: hidden;
	cursor: pointer;
}
.img_box .video_box .zhezhao img{
	width: 100%;
	height: 100%;
	transition:all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc{
	display: block;
}
.img_box .video_box .zhezhao img.img_wap{
	display: none;
}
.img_box .video_box video{
	width: 100%;
}
.classify_box {
  width: 100%;
  height: 116px;
  overflow: hidden;
  background: #fafafa;
}
.classify_box p {
  margin-top: 12px;
  text-align: right;
  padding-right: 60px;
  font-size: 12px;
  color: #000000;
  font-family: Font_Light;
}
.classify_box select {
  width: 198px;
  padding: 0 15px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #000;
  background: none;
  float: right;
  margin: 12px 30px 0 0;
  font-size: 14px;
  color: #000000;
  font-family: Font_Light;
}

.pro_box {
  overflow: hidden;
}
.pro_box li {
  width: 30%;
  margin: 5% 5% 8% 0;
  float: left;
  text-align: center;
  overflow: hidden;
  position: relative;
}
.pro_box li:nth-child(3n) {
  margin: 5% 0 8% 0;
}
.pro_box li a {
  color: #000;
}
.pro_box li a:hover {
  color: #000;
}
.pro_box li i {
  padding: 0 10px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  letter-spacing: 1px;
  font-style: normal;
  font-size: 13px;
  font-family: Font_Regular;
  border: 1px solid #000;
  z-index: 2;
  margin: 40px auto 0;
}
.pro_box li .li_img {
  width: 100%;
  overflow: hidden;
  padding-top: 135%;
  position: relative;
}
.pro_box li .li_img img {
  max-width: 100%;
  max-height: 100%;
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.pro_box li .li_text {
  text-align: center;
}
.pro_box li .li_text p {
  letter-spacing: 2px;
  font-size: 15px;
  font-family: Font_Medium;
  margin: 0 0 10px 0;
}
.pro_box li .li_text p em {
  letter-spacing: 1px;
  display: block;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
}
.pro_box li .li_text span {
  display: inline-block;
  padding: 0 16px;
  text-align: center;
  letter-spacing: 2px;
  height: 34px;
  line-height: 34px;
  color: #fff;
  background: #000;
  font-size: 15px;
  font-family: Font_Normal;
}
/*------------brand.html  end----------------*/
</style>


// WEBPACK FOOTER //
// src/view/Html/MAESOUL.vue